export const isInt = (value) => {
  // taken from formsy-react validation helper
  if (value && !/^(?:[-+]?(?:0|[1-9]\d*))$/.test(value)) {
    return 'Number required';
  }
  return undefined;
};

export default isInt;
